import React from 'react'

function Reviews() {
    return (
        <div>
           <h1> Reviews</h1>
        </div>
    )
}

export default Reviews
